import React from "react"
import {
  FaHands,
  FaLeaf,
  FaSpa,
  FaHotTub,
  FaSwimmingPool,
} from "react-icons/fa"

import SEO from "../components/common/SEO"
import ServiceHero from "../components/services/ServiceHero"
import ServiceCategoryCard from "../components/services/ServiceCategoryCard"

export default function Services() {
  const categories = [
    {
      id: 1,
      title: "Massages",
      description:
        "Découvrez notre sélection de massages relaxants, ayurvédiques, orientaux et thérapeutiques conçus pour rétablir l'équilibre du corps et de l'esprit.",
      image: "/images/service-massage.jpg",
      icon: <FaHands />,
      link: "/services/massages",
    },
    {
      id: 2,
      title: "Soins du Visage",
      description:
        "Des soins professionnels adaptés à chaque type de peau pour hydrater, purifier, illuminer et revitaliser votre visage.",
      image: "/images/service-facial.jpg",
      icon: <FaLeaf />,
      link: "/services/soins-visage",
    },

    {
      id: 3,
      title: "Beauté des Mains & Pieds",
      description:
        "Manucure, pédicure et soins esthétiques réalisés avec expertise pour une beauté raffinée jusqu'au bout des doigts.",
      image: "/images/service-onglerie.jpg",
      icon: <FaSpa />,
      link: "/services/beaute",
    },

    {
      id: 4,
      title: "Rituels Spa",
      description:
        "Des expériences bien-être exclusives combinant hammam, soins du corps, enveloppements et massages relaxants.",
      image: "/images/gallery-6.jpg",
      icon: <FaHotTub />,
      link: "/services/rituels",
    },

    {
      id: 5,
      title: "Installations Bien-Être",
      description:
        "Profitez de notre piscine intérieure chauffée, hammam traditionnel, salle de remise en forme et espaces de détente.",
      image: "/images/pool.jpg",
      icon: <FaSwimmingPool />,
      link: "/services/installations",
    },

  ]

  return (
    <>
      <SEO
        title="Services Spa & Bien-être | Centre Spa Land Saphir Palace"
        description="Découvrez nos massages, soins du visage, soins beauté, rituels spa, piscine intérieure chauffée et espace fitness à Hammamet."
        keywords="spa hammamet, massage hammamet, soins visage hammamet, hammam tunisie, centre bien être hammamet"
        url="https://www.yourdomain.com/services"
      />

      <main>
        <ServiceHero />

        <section className="section-padding bg-[#f9f6f1]">
<div className="mx-auto max-w-7xl px-6">
<div className="mx-auto mb-16 max-w-3xl text-center">
  <h2 className="mb-4 text-4xl font-bold text-gray-900">
    Nos Services
  </h2>

  <p className="text-lg leading-relaxed text-gray-600">
    Découvrez une sélection de soins et d'expériences bien-être
    conçus pour vous offrir détente, sérénité et revitalisation.
  </p>
</div>

<div className="flex flex-wrap justify-center gap-8">
  {categories.map((category) => (
    <div
      key={category.id}
      className="w-full md:w-[45%] xl:w-[30%] max-w-md"
    >
      <ServiceCategoryCard
        title={category.title}
        description={category.description}
        image={category.image}
        icon={category.icon}
        link={category.link}
      />
    </div>
  ))}
</div>
          </div>
        </section>

        {/* CTA */}
        <section
          style={{
            padding: "100px 20px",
            textAlign: "center",
            background: "#111",
            color: "#fff",
          }}
        >
          <h2
            style={{
              fontSize: "2.5rem",
              marginBottom: "20px",
            }}
          >
            Réservez Votre Moment de Détente
          </h2>

          <p
            style={{
              maxWidth: "700px",
              margin: "0 auto 30px",
              color: "#ddd",
            }}
          >
            Contactez-nous dès aujourd'hui pour
            réserver votre soin ou obtenir plus
            d'informations sur nos prestations.
          </p>

          <a
            href="https://wa.me/21697902051"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: "#b8955d",
              color: "#fff",
              padding: "14px 30px",
              borderRadius: "50px",
              textDecoration: "none",
              fontWeight: "600",
            }}
          >
            Réserver via WhatsApp
          </a>
        </section>
      </main>
    </>
  )
}